import { atom } from 'recoil';

export const OnNoticeTypeAtom = atom<'create' | 'edit' | null>({
	key: 'onNoticeType',
	default: null,
});
